export default "__VITE_ASSET__ef7775d1__"